module.exports = __webpack_public_path__ + "img/writing.ea91d3cd.jpeg";